export const PORTFOLIO_FALLBACKS = {
  video: "/portfolio-video.svg",
  audio: "/portfolio-audio.svg",
};

function youtubeThumbnail(url) {
  if (!url) return "";

  try {
    const parsed = new URL(url);
    let videoId = "";

    if (parsed.hostname === "youtu.be") {
      videoId = parsed.pathname.split("/").filter(Boolean)[0] || "";
    } else if (parsed.hostname.endsWith("youtube.com")) {
      videoId = parsed.searchParams.get("v") || "";
      if (!videoId && parsed.pathname.startsWith("/shorts/")) {
        videoId = parsed.pathname.split("/")[2] || "";
      }
      if (!videoId && parsed.pathname.startsWith("/embed/")) {
        videoId = parsed.pathname.split("/")[2] || "";
      }
    }

    return videoId
      ? `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`
      : "";
  } catch {
    return "";
  }
}

export function getPortfolioImage(item) {
  const type = item?.type === "video" ? "video" : "audio";
  return item?.thumb || (type === "video" && youtubeThumbnail(item?.url)) || PORTFOLIO_FALLBACKS[type];
}
